// src/stores/blog-store.js
import { defineStore } from "pinia";
import { httpRequest } from "@/services/api";
import { showAlert } from "@/composables/useAlert";

export const useBlogStore = defineStore("blog", {
  state: () => ({
    blogs: [],
    isLoading: false,
  }),

  actions: {
    async fetchBlogs(pageSize = 20) {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/blog?pageSize=${pageSize}`, {
          method: "GET",
        });
        this.blogs = res.data || [];
        console.log("Blogs:", this.blogs);
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب المقالات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
});
